import React from 'react';
import ReactDOM from 'react-dom'
import L from 'leaflet';

//import 'leaflet/dist/leaflet.css';  //default marker se ni kazal, če je bilo to vključeno tukaj

import 'leaflet-control-geocoder';

import 'leaflet-control-geocoder/dist/Control.Geocoder.css';

class Map extends React.Component {
  componentDidMount() {
    // create map
    this.map = L.map('map', {
      center: [46.119944, 14.35333],
      zoom: 9,
      zoomControl: false
    });

    const baseMaps = {
      "OpenStreetMap": L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }),
      "DOF": L.tileLayer.wms("http://prostor4.gov.si:80/ows2-m-pub/wms?", {
        layers:"SI.GURS.ZPDZ:DOF050",
        attribution: '<a href="http://www.e-prostor.gov.si/dostop-do-podatkov/dostop-do-podatkov/#c501">Geodetska uprava Republike Slovenije</a>'
      })
    };

    const overlays = {
      "Občine":  L.tileLayer.wms("http://prostor4.gov.si:80/ows2-m-pub/wms?", {
        layers:"table_gurs_pub:SI.GURS.RPE.LS",
        format: "image/png",
        transparent: "true",
        attribution: '<a href="http://www.e-prostor.gov.si/dostop-do-podatkov/dostop-do-podatkov/#c501">Geodetska uprava Republike Slovenije</a>'
      })
    };

    L.control.layers(baseMaps, overlays).addTo(this.map);

    baseMaps['OpenStreetMap'].addTo(this.map);

    L.control.zoom({
      position:'bottomright'
    }).addTo(this.map);

    let map = this.map;

    L.Control.geocoder({
      geocoder: L.Control.Geocoder.nominatim(),
      defaultMarkGeocode: false,
      placeholder: "Iskanje ...",
      errorMessage: "Iskanje ni obrodilo sadov."
    }).on('markgeocode', function(e) {
      var bbox = e.geocode.bbox;
      var poly = L.polygon([
        bbox.getSouthEast(),
        bbox.getNorthEast(),
        bbox.getNorthWest(),
        bbox.getSouthWest()
      ]);
      map.fitBounds(poly.getBounds());
      map.openPopup(e.geocode.name, e.geocode.center);
    }).addTo(map);

    //make custom controls if defined in props.children
    let leafletControlComponents = React.Children.toArray(this.props.children).filter(x => x.props.leafletControl === true)

    leafletControlComponents.map(x => this.createCustomControl(x))

    this.props.setReference( this.map );

  }

  createCustomControl(control) {
    var customControl = L.Control.extend({
      options: {
        position: 'topleft' 
          //control position - allowed: 'topleft', 'topright', 'bottomleft', 'bottomright'
        },
        onAdd: function (map) {
          var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
          return container;
        },
    });

    if (control.props.name === 'DrawerToggler') {
      control = React.cloneElement(control, {'toggleDrawerState': this.props.toggleDrawerState});
    }

    let toggler=new customControl();
    this.map.addControl(toggler);
    let container = toggler.getContainer();
    ReactDOM.render(control,container)
    //ReactDOM.render(<DrawerToggler/>,container) //http://www.deadcoderising.com/react-16-render-a-child-component-into-another-dom-node-using-portals/
    //https://stackoverflow.com/questions/46393642/how-to-use-reactdom-createportal-in-react-16
  }

  render() {
    return <div id="map" style={{height:'100vh'}}></div>
  }
}
export default Map;